import { render, staticRenderFns } from "./unverified.vue?vue&type=template&id=1da58b5e&scoped=true"
import script from "./unverified.vue?vue&type=script&lang=ts"
export * from "./unverified.vue?vue&type=script&lang=ts"
import style0 from "./unverified.vue?vue&type=style&index=0&id=1da58b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da58b5e",
  null
  
)

export default component.exports